(() => {
  const SELECTOR = '.jdgm-carousel-item .jdgm-product-name a[href*="/products/"]:not([data-ahf-shop])';

  const upgrade = () => {
    document.querySelectorAll(SELECTOR).forEach((link) => {
      link.dataset.ahfShop = '';
      if (link.querySelector('img, picture, svg, video')) return;
      const name = link.textContent.trim();
      if (!name || name.length > 60 || name.startsWith('Shop ')) return;
      link.classList.add('ahf-review-product-link');
      link.textContent = `Shop ${name} →`;
      link.setAttribute('aria-label', `Shop ${name}`);
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      upgrade();
    });
  };

  upgrade();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
})();
